export default __webpack_public_path__ + "static/media/play.d7dbc7d9.svg";